import type { Plan } from '@/services/billing/plans';
import { type OrdwayPlanBillingPlan, planCustomFields } from '@/services/billing/transforms';

/**
 * The loaded Ordway plan matching a static plan by type, when available. Matches on the plan-level
 * `custom_fields.plan_type` (a free-form wire string) against the static plan type. Supplies the
 * checkout link's `ordwayPlanID`.
 */
export function findOrdwayPlan(
  ordwayPlans: OrdwayPlanBillingPlan[] | undefined,
  plan: Plan,
): OrdwayPlanBillingPlan | undefined {
  return ordwayPlans?.find((ordwayPlan) => planCustomFields(ordwayPlan).plan_type === plan.planType);
}
